import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from "react-redux";
import {compose} from "recompose";
import SalesSummaryBihourlyReportTable from '../components/SalesSummaryBihourlyReportTable';
import {getGetHeaders} from '../shared/serverFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import {RESOURCES as reportsResources} from '../fuseSalesSummaryReportsResourceMap';
import Config from '../messages';

/**
 * Class for retrieving Sales Summary data for multiple tables
 *
 */
class SalesSummaryBihourlyReportSet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataIsFiltered: false,
            dataBihourly: {},
            dataProcessed: false,
            errorMessage: null,
            reportName: 'Sales Summary Bihourly',
            bihourlySummaryComplete: false,
            summariesComplete: false,
        };
        this.checkSummaryCompletion = this.checkSummaryCompletion.bind(this);
    }

    componentWillMount() {
        this.fetchData('all');
    }

    componentWillReceiveProps(nextProps) {
        let clearData = false;
        // If initial date range or filter choices change, reset
        if (
            nextProps.startDate !== this.props.startDate ||
            nextProps.endDate !== this.props.endDate ||
            nextProps.offset !== this.props.offset ||
            nextProps.filterChoiceFirst !== this.props.filterChoiceFirst ||
            nextProps.filterChoiceSecond !== this.props.filterChoiceSecond ||
            nextProps.filterType !== this.props.filterType
        ) {
            clearData = true;
        }
        if (clearData) {
            this.setState({
                dataIsFiltered: false,
                dataBihourly: {},
                dataProcessed: false,
                errorMessage: null,
                summariesComplete: false
            });
        }
    }

    componentDidUpdate(prevProps) {
        let dataTypeToFetch = 'none';
        if (
            prevProps.startDate !== this.props.startDate ||
            prevProps.endDate !== this.props.endDate ||
            prevProps.offset !== this.props.offset ||
            (prevProps.filterType !== 'all' && this.props.filterType === 'all')
        ) {
            dataTypeToFetch = 'all';
        }
        if (
            prevProps.filterChoiceFirst !== this.props.filterChoiceFirst ||
            prevProps.filterChoiceSecond !== this.props.filterChoiceSecond ||
            prevProps.totalFiltersAvailable !== this.props.totalFiltersAvailable
        ) {
            if (this.props.totalFiltersAvailable === 2) {
                dataTypeToFetch = (this.props.filterChoiceSecond) ? 'filter' : 'none';
            } else if (this.props.totalFiltersAvailable === 1) {
                dataTypeToFetch = 'filter';
            }
        }
        if (dataTypeToFetch === 'filter') {
            this.fetchData(prevProps.filterType);
        } else if (dataTypeToFetch === 'all') {
            this.fetchData('all');
        }
    }

    /* API Calls ------------------------------ */

    /**
     * Get filtered data by a specific date range
     *
     * @param dataType
     */
    fetchData(dataType) {

        // Assemble the URI
        const params = {
            start_date: this.props.startDate,
            end_date: this.props.endDate,
            offset: this.props.offset,
        };

        // Update parameters and set resource based on data filter
        let resource;

        let firstFilterValue, secondFilterValue;
        if (dataType !== 'all') {
            if (this.props.filterChoiceFirst) {
                firstFilterValue = this.props.filterChoiceFirst;
            }
            if (this.props.filterChoiceSecond) {
                secondFilterValue = this.props.filterChoiceSecond;
            }
        }
        let dataIsFiltered = (dataType !== 'all');

        // Set additional params and select API path based on data type
        switch (dataType) {
            case 'statecity':
                params.state = firstFilterValue;
                params.city = secondFilterValue;
                resource = reportsResources.SalesSummaryHourlyByStateCity.GET_LIST(params);
                break;
            case 'statedba':
                params.state = firstFilterValue;
                params.dba_id = secondFilterValue;
                resource = reportsResources.SalesSummaryHourlyByStateDba.GET_LIST(params);
                break;
            case 'dba':
                params.dba_id = firstFilterValue;
                resource = reportsResources.SalesSummaryHourlyByDba.GET_LIST(params);
                break;
            case 'district':
                params.district_id = firstFilterValue;
                resource = reportsResources.SalesSummaryHourlyByDistrict.GET_LIST(params);
                break;
            case 'location':
                params.location_id = firstFilterValue;
                resource = reportsResources.SalesSummaryHourlyByLocation.GET_LIST(params);
                break;
            case 'state':
                params.state = firstFilterValue;
                resource = reportsResources.SalesSummaryHourlyByState.GET_LIST(params);
                break;
            default:
                // Get all data
                resource = reportsResources.SalesSummaryBihourlyAll.GET_LIST(params);
                break;
        }

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data && result.data.payload) {
                this.processData(dataIsFiltered, result.data.payload);
            }
        }).catch((error) => {
            let message = Config.fuse.error.error + this.state.reportName + '.';
            if (error.response) {
                // Server response outside 2xx
                if (error.response.data && error.response.data.error) {
                    message = Config.fuse.error.error + this.state.reportName + ': ' + error.response.data.error;
                }
            } else if (error.request) {
                // No response
                message = Config.fuse.error.no_response + this.state.reportName + '.';
            } else {
                console.log('Error', error.message);
            }
            this.setState({
                bihourlySummaryComplete: true,
                dataBihourly: {},
                dataProcessed: true,
                summariesComplete: true,
                errorMessage: message
            }, () => {
                this.checkSummaryCompletion();
                this.props.onDataProcessed('bihourly');
            });
        });
    }

    /* Data Processing ------------------------------ */

    /**
     * Pass results to table(s)
     *
     * @param dataIsFiltered
     * @param data
     */
    processData(dataIsFiltered, data) {

        let dataBihourly = {};
        if (data.aggregations) {
            dataBihourly = data.aggregations;
        }

        // Finalize dataset
        this.setState({
            dataIsFiltered: dataIsFiltered,
            dataBihourly: dataBihourly,
            dataProcessed: true,
            errorMessage: null
        }, () => {
            this.props.onDataProcessed('bihourly');
        });
    }

    /* Event Handling ------------------------------ */

    // Handle event from table components
    handleSummaryComplete = (summary, isComplete) => {
        if (summary === 'bihourly') {
            this.setState({
                bihourlySummaryComplete: isComplete,
            }, () => {
                this.checkSummaryCompletion();
            });
        }
    };

    // Determine if all summaries are complete
    // (Currently only one completed summary is needed)
    checkSummaryCompletion = () => {
        const {
            bihourlySummaryComplete
        } = this.state;

        if (bihourlySummaryComplete) {
            this.props.onSummariesComplete('bihourly', true);
        }
    };

    /* Table Collection Display ------------------------------ */

    render() {

        const {
            endDate,
            offset,
            startDate,
            system,
        } = this.props;

        const {
            dataIsFiltered,
            dataBihourly,
            dataProcessed,
            errorMessage
        } = this.state;

        return (
            <div>
                {dataProcessed &&
                <div>

                    {/* Table: Sales Summary Bihourly */}
                    {dataBihourly &&
                    <SalesSummaryBihourlyReportTable
                        dataObject={dataBihourly}
                        dataIsFiltered={dataIsFiltered}
                        endDate={endDate}
                        offset={offset}
                        startDate={startDate}
                        system={system}
                        onSummaryComplete={this.handleSummaryComplete}
                    />
                    }
                </div>
                }

                {/* Error and Messaging */}
                {errorMessage &&
                    <div className="error">
                        <p>{errorMessage}</p>
                    </div>
                }
            </div>
        )
    }
}

SalesSummaryBihourlyReportSet.propTypes = {
    addField: PropTypes.bool,
    endDate: PropTypes.string,
    filterChoiceFirst: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.object,
        PropTypes.string,
    ]),
    filterChoiceSecond: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.object,
        PropTypes.string,
    ]),
    filterType: PropTypes.string,
    offset: PropTypes.string.isRequired,
    onDataProcessed: PropTypes.func,
    onSummariesComplete: PropTypes.func,
    startDate: PropTypes.string,
    system: PropTypes.string,
    totalFiltersAvailable: PropTypes.number,
};

SalesSummaryBihourlyReportSet.defaultProps = {
    addField: true,
    endDate: null,
    filterChoiceFirst: null,
    filterChoiceSecond: null,
    filterType: 'all',
    offset: null,
    startDate: null,
    totalFiltersAvailable: 0,
};

const enhance = compose(
    connect()
);

export default enhance(SalesSummaryBihourlyReportSet);



// WEBPACK FOOTER //
// ./src/Fuse/components/SalesSummaryBihourlyReportSet.js